export default __webpack_public_path__ + "fa855c1de59733d767956782f42237b7.png";